// Default monthly specials.
// Used by the menu page when nothing has been saved from the admin yet (or if the
// live data can't be loaded), and by the admin as the starting point for editing.
export const DEFAULT_SPECIALS = {
  heading: 'OCTOBER SPECIALS',
  items: [
    { name: 'Brown Sugar Maple Sea Salt Latte', price: '$7.75', description: '' },
    { name: 'Cinnamon Roll Latte', price: '$7.85', description: '' },
    { name: 'Cinnamon Roll Matcha', price: '$8.75', description: '' },
    { name: 'Pumpkin Cookie Latte', price: '$7.85', description: '' },
  ],
  cloudTopping: { name: 'Cinnamon Sugar Cloud', price: '$1.50' },
};

const str = (v) => (typeof v === 'string' ? v : v == null ? '' : String(v));

export function cloneSpecials(specials) {
  return JSON.parse(JSON.stringify(specials));
}

// Turn whatever is stored in Firestore into the exact shape the UI expects.
export function normalizeSpecials(data) {
  if (!data || typeof data !== 'object') return cloneSpecials(DEFAULT_SPECIALS);
  const items = Array.isArray(data.items)
    ? data.items
        .filter((it) => it && typeof it === 'object')
        .map((it) => ({
          name: str(it.name),
          price: str(it.price),
          description: str(it.description),
        }))
    : [];
  const ct = data.cloudTopping && typeof data.cloudTopping === 'object' ? data.cloudTopping : {};
  return {
    heading: str(data.heading),
    items,
    cloudTopping: { name: str(ct.name), price: str(ct.price) },
  };
}

// Trim everything and drop blank rows before saving.
export function cleanSpecials(specials) {
  const s = normalizeSpecials(specials);
  return {
    heading: s.heading.trim(),
    items: s.items
      .map((it) => ({ name: it.name.trim(), price: it.price.trim(), description: it.description.trim() }))
      .filter((it) => it.name),
    cloudTopping: { name: s.cloudTopping.name.trim(), price: s.cloudTopping.price.trim() },
  };
}
